let list = [];
const event = {
    on(instance, eventType, eventAction) {
        const eventKey = `${eventType}-${instance}`;
        const event = list.find(item => item.eventKey === eventKey);
        if (!event) {
            list.push({ eventKey, eventType, eventAction });
        }
        return this;
    },
    off(instance, eventType) {
        const eventKey = `${eventType}-${instance}`;
        list = list.filter(item => item.eventKey !== eventKey);
    },
    emit(eventType, ...args) {
        const events = list.filter(item => item.eventType == eventType);
        events.forEach(item => {
            item.eventAction(...args);
        });
    },
};

export { event as default };
//# sourceMappingURL=events.js.map
